import styles from './Memory.module.scss';
import cn from "classnames";
import {Component, useMemo} from "react";

export class Memory extends Component {
    state = {
        first: null,
        second: null,
        counter: 0,
        openCard: false,
        openAllCard: false,
        arr: this.props.arr
    }

    verification = () => {
        if (this.state.counter === 10) {
            this.props.handler(true);
        }
    }

    checker = () => {
        const firstIndex = this.state.first.getAttribute("data-index"),
            secondIndex = this.state.second.getAttribute("data-index");
        if (firstIndex === secondIndex) {
            this.setState(({counter}) => ({counter: ++counter}), () => this.verification())
            this.setState({ openCard: false });
            this.setState({ openAllCard: false });

        } else {
            setTimeout(() => {
                this.state.first.classList.remove(styles.rotate);
                this.state.second.classList.remove(styles.rotate);

                this.setState({ first: null });
                this.setState({ second: null });
                this.setState({ openCard: false });
                this.setState({ openAllCard: false });
            }, 1000);
        }
    }

    clickHandler = (e) => {
        if (!this.state.openCard) {
            this.setState({ first: e.currentTarget });
            this.setState({ openCard: true });
            e.currentTarget.classList.add(styles.rotate);
        } else if (!e.currentTarget.classList.contains(styles.rotate) && (!this.state.openAllCard)) {
            this.setState({ second: e.currentTarget }, () => this.checker());
            this.setState({ openAllCard: true });
            e.currentTarget.classList.add(styles.rotate);
        }
    }

    render() {
        const {children} = this.props;

        return (
            <div className={styles.memory}>
                <div className={styles.block}>
                    <List arr={this.state.arr} handler={this.clickHandler}/>
                </div>
                {children}
            </div>
        )
    }
}

const List = ({arr, handler}) => {

    const list =  arr.map((item, index) => {
        return (
            <li key={index} className={styles.item} data-index={item} onClick={e => handler(e)}>
                <div className={cn("box-white-6", styles.img, styles.pic, styles.wrap, styles[`wrap-${item}`])}>
                    <img src={`${process.env.PUBLIC_URL}/elements/${item}.png`} alt="2x2"/>
                </div>
                <div className={cn(styles.img, styles.bg, "box-white-6")}/>
            </li>
        )
    });

    //eslint-disable-next-line
    return useMemo(() => list, [arr]);
}